<!-- src/components/ErrorPage.vue -->
<template>
  <div class="error-page">
    <h1>Error 404</h1>
    <p>The page you are looking for does not exist.</p>
    <router-link to="/">Go back to Home</router-link>
  </div>
</template>

<script setup>
// No script content needed for this simple example
</script>

<style scoped>
.error-page {
  text-align: center;
  margin-top: 50px;
}

h1 {
  font-size: 3em;
  color: #ff4d4f;
}

p {
  font-size: 1.5em;
  color: #888;
}
</style>
